import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

export const CaseStudyCard = ({ study, index }) => (
  <Reveal delay={index * 0.08} className="h-full">
    <Link
      to="/case-studies"
      data-testid={`case-study-card-${study.id}`}
      className="group flex h-full flex-col rounded-2xl border border-zinc-800 bg-ink-900/60 p-7 transition-colors duration-500 hover:border-volt/40"
    >
      <div className="flex items-center justify-between">
        <span className="rounded-full border border-volt/25 bg-volt/[0.06] px-3 py-1 font-mono text-[10px] uppercase tracking-[0.18em] text-volt">
          {study.label}
        </span>
        <span className="font-mono text-[11px] text-zinc-600">{study.id}</span>
      </div>
      <h3 className="mt-6 font-display text-2xl font-bold tracking-tight text-zinc-100">
        {study.title}
      </h3>
      <p className="mt-2 text-sm leading-relaxed text-zinc-400">{study.summary}</p>
      <div className="mt-5 flex flex-wrap gap-2">
        {study.scope.slice(0, 6).map((s) => (
          <span
            key={s}
            className="rounded-md border border-zinc-800 px-2 py-1 font-mono text-[10px] text-zinc-500"
          >
            {s}
          </span>
        ))}
      </div>
      <span className="mt-auto inline-flex items-center gap-1.5 pt-7 font-mono text-[11px] uppercase tracking-[0.2em] text-zinc-500 transition-colors duration-300 group-hover:text-volt">
        View Case Study
        <ArrowRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-1" />
      </span>
    </Link>
  </Reveal>
);
